import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';

import { updateLessonById } from 'store/lesson/actions';

import KindSettings from './KindSettings';

const KindSettingsContainer = ({ setCurrentStep }: { setCurrentStep: any }) => {
  const dispatch = useAppDispatch();
  const { values } = useFormikContext<any>();

  const { lessonId } = useParams();

  const handleOptionClick = (option: any) => {
    try {
      dispatch(
        updateLessonById({
          lessonId,
          lessonType: values.type,
          data: { kind: option.value },
          changedPropertiesKeys: ['kind'],
        }),
      );

      setCurrentStep(2);
    } catch (error) {
      console.warn(error);
    }
  };

  return <KindSettings onOptionClick={handleOptionClick} />;
};

export default React.memo(KindSettingsContainer) as any;
